const START_PATTERN = /^\d{1,12}$/;

export function normalizeInvoiceStart(value) {
  return String(value ?? '').replace(/\D/g, '').slice(0, 12);
}

export function previewInvoiceNumber(prefix, start) {
  const digits = String(start ?? '').trim();
  if (!digits) return '';
  if (!START_PATTERN.test(digits)) return '';
  return `${String(prefix ?? '')}${digits}`;
}

export function isCustomInvoiceSequenceEnabled(start) {
  return START_PATTERN.test(String(start ?? '').trim());
}
